module.exports = __webpack_public_path__ + "8199f74edc103d3b9b9847ddd4dd7d29.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/banner1.png
// module id = 779
// module chunks = 79